import { render, staticRenderFns } from "./TrackingBoard.vue?vue&type=template&id=6f1bf9db&"
import script from "./TrackingBoard.vue?vue&type=script&lang=ts&"
export * from "./TrackingBoard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports